<template>
    <div>
        <div class="position-relative">
            <b-form-input
                v-model="search"
                @focus="showDropdown = true"
                @input="showDropdown = true"
                @blur="hideDropdown"
                placeholder=""
                autocomplete="off"
            />

            <div
            v-if="showDropdown && filteredOptions.length"
            class="dropdown-menu d-block w-100"
            style="max-height: 500px; overflow-y: auto;"
            >
            <button
                v-for="(option, idx) in filteredOptions"
                :key="idx"
                class="dropdown-item text-left"
                @mousedown.prevent="selectOption(option)"
            >
                <div><strong>{{ option[config.table_column] }}</strong></div>
                <small class="text-muted">
                <span
                    v-for="(column, i) in config.table_columns"
                    :key="i"
                >
                    {{ option[column.column] }}
                    <span v-if="i < config.table_columns.length - 1"> - </span>
                </span>
                </small>
            </button>
            </div>

        </div>

        <div style="margin:5px; margin-left:15px; padding-left:5px; border-left: 1px black solid">

            <b-button variant="link" v-if="visible_filters" @click="visible_filters = false"><i class="fas fa-caret-down"></i> Filtres</b-button>
            <b-button variant="link" v-else @click="visible_filters = true"><i class="fas fa-caret-right"></i> Filtres</b-button>

            <b-collapse v-model="visible_filters" :id="'collapse' + id">

           <!-- <b-form-checkbox v-model="fuzzySearch" switch class="mt-2">
                Recherche par mots-clés (ordre libre)
            </b-form-checkbox> -->

                <div v-for="(column, idx) in config.table_columns" :key="idx">
                    <p v-if="column.filter == 'radio'">
                        {{ column.column }}<br />
                        <b-form-radio inline v-model="filters[column.column]" name="name">&nbsp;</b-form-radio>
                        <b-form-radio inline v-for="(option, idx) in [...new Set(initial_data.map(item => item[column.column]))].sort()" :key="idx" v-model="filters[column.column]" name="name" :value="option">{{ option }}</b-form-radio>
                    </p>
                    <p v-if="column.filter == 'list'">
                        {{ column.column }}<br />
                        <v-select v-model="filters[column.column]" :options="[...new Set(initial_data.map(item => item[column.column]))].sort()"></v-select>
                    </p>
                </div>
            </b-collapse>
    </div>
  </div>
</template>
  
  <script>

	import uniqueId from "lodash.uniqueid";
  import alasql from "alasql";

  import database from "../services/database.js";

  export default {
    name: "select_db",
	components: {
	},
    props: {
        config: {
            default: () => {}
        },
        index: 0,
        column: "", 
        start_value: "",
        id_index: ""

},
	data () {
	  return {
		id: uniqueId(),
        visible_filters: true,
		initial_data: [],
		data: [],
		search: "",
		request: "",
        fuzzySearch: true,
        showDropdown: false,
        filters: {
        }
	  }
	},
	watch: {
        async id_index()
        {
            await this.$nextTick();
            this.search = this.start_value;

            if (this.search)
                this.visible_filters = false;
            else
                this.visible_filters = true;

            this.filters = {};
        },
        search()
        {
            this.$emit('update', this.index, this.column, this.search);
        },
		filters: {
            deep: true,
            handler() {
                this.request = "";

                var keys = Object.keys(this.filters);
                for (var i = 0; i < keys.length; i++)
                {
                    if (this.filters[keys[i]])
                    {
                        if (this.request)
                            this.request += " and ";
                        this.request += "`" + keys[i] + "` = \"" + this.filters[keys[i]] + "\""
                    }
                }

                if (this.request)
                    this.request = "where " + this.request;

                console.log(this.request);

                this.data = alasql(
                    "SELECT * FROM ? " + this.request,
                    [this.initial_data]
                );
            }    
		}
	},
    computed: {
        filteredOptions() {
            const input = this.search.toLowerCase().trim();
            if (!input) return this.data;

            const keywords = input.split(/\s+/);

            const exactMatches = [];
            const fuzzyMatches = [];

            this.data.forEach(option => {
            const combinedText = this.config.table_columns
                .map(c => (option[c.column] || '').toLowerCase())
                .join(' ');

            if (!this.fuzzySearch) {
                // Recherche stricte
                if (combinedText.includes(input)) {
                exactMatches.push(option);
                }
            } else {
                // Recherche "floue" : tous les mots présents
                const allWordsFound = keywords.every(kw => combinedText.includes(kw));
                if (combinedText.includes(input)) {
                // Si les mots sont dans l’ordre => priorité
                exactMatches.push(option);
                } else if (allWordsFound) {
                fuzzyMatches.push(option);
                }
            }
            });

            return [...exactMatches, ...fuzzyMatches];
        }
    },
	methods: {
        selectOption(option) {
            this.search = option[this.config.table_column];
            this.showDropdown = false;
        },
        hideDropdown() {
            setTimeout(() => (this.showDropdown = false), 200);
        }
	},
	async mounted() {

        this.search = this.start_value;

        if (this.search)
            this.visible_filters = false;

        this.initial_data = await database.get("SELECT", this.config.table, {
            end: "order by `" + this.config.table_column + "`" 
        });

		this.data = alasql(
			"SELECT * FROM ? " + this.request,
			[this.initial_data]
		);

	}
  };
  </script>